import { maxLengthCut } from '@direct-frontend/stdlib';

import { getSelector } from './getSelector';

// Максимальная длина URL изображения, на котором был вызван LCP,
// чтобы не превышать лимитов по данным для отправки в RUM
const MAX_URL_LENGTH = 250;

/**
 * Хелпер для сбора дополнительной информации об элементе, который вызвал LCP.
 *
 * @kind helper
 * @param largestContentfulPaint Содержимое PerformanceEntry при логировании LCP.
 * @returns Дополнительная информация об элементе, который вызвал LCP, для отправки в Rum счетчик.
 **/
export function getLCPAdditionalParams(
    largestContentfulPaint?: Ya.Rum.LargestContentfulPaint | undefined | null
): Record<string, string> | undefined {
    if (!largestContentfulPaint) {
        return;
    }

    const { element, size, url } = largestContentfulPaint;

    return {
        // Селектор элемента, который вызвал LCP и unknown, если элемент не найден на странице.
        lcp_selector: element ? getSelector(element) : 'unknown',
        // Размер элемента в виде его площади.
        lcp_size: String(size),
        // Если элемент картинка, то возвращаем URL данной картинки.
        lcp_url: maxLengthCut(url, MAX_URL_LENGTH, ''),
        // Если элемент картинка, то возвращаем длину URL данной картинки, чтобы понять насколько он обрезан.
        lcp_url_length: String(url.length),
    };
}
